import { template as template_2c59a633d5b04bb5bea71d7b49613202 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import CardError from '@cardstack/host/components/card-error';
import type { ErrorModel as IndexRouteErrorModel } from '@cardstack/host/routes/index';
interface Signature {
    Args: {
        model: IndexRouteErrorModel;
    };
}
const IndexErrorRouteComponent: TemplateOnlyComponent<Signature> = template_2c59a633d5b04bb5bea71d7b49613202(`
  <CardError
    @type={{@model.loadType}}
    @message={{@model.message}}
    @operatorModeState={{@model.operatorModeState}}
  />
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default RouteTemplate(IndexErrorRouteComponent);
